import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import InputField from "../../../jsx/components/fields/inputField";
import PrimaryButton from "../../../jsx/components/button/primaryButton";
import {
  emailValidation,
  noSpaceOnChange,
  phoneOnChange,
  phoneValidation,
  firstNameValidation,
} from "../../../functions/validations";
import { useNavigate, useLocation } from "react-router-dom";
import PhonenumberField from "../../../jsx/components/fields/phoneFields";
import ResponceToaster from "../../../jsx/components/responceToaster/responceToaster";
import html2canvas from "html2canvas";
import TextArea from "../fields/textArea";
import sendOverallFeedback from "../../../service/api/user/sendOverallFeedback";
import { BiStar } from "react-icons/bi";
import { BsStarFill } from "react-icons/bs";
import { callNote } from "../../../service/api/callHistory/callNote";

const TwilioRoomScreenShotModal = ({ addUserTrigger, handleCloseAddUser, joinCallResult, roomValue }) => {
  const { role, userName, phoneCodeRedux, phoneNumberRedux, emailRedux } =
    useSelector((state) => state.user);

  const newH = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loaderActive, setLoaderActive] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [feedBackMsg, setFeedBackMsg] = useState("");
  const [isFeedBackError, setIsFeedBackError] = useState(false);
  const [image, setImage] = useState();
  const checkHW = useRef(null);
  const [imgMaxHeight, setImgMaxHeight] = useState(0);
  const [imgMaxWidth, setImgMaxWidth] = useState(0);
  const [showImg, setShowImg] = useState(null);


  useEffect(() => {
    const height = checkHW?.current?.getBoundingClientRect()?.height;
    const width = checkHW?.current?.getBoundingClientRect()?.width;
    setImgMaxWidth(width);
    setImgMaxHeight(height);
  }, []);



  function onChangeFeedBackMsg(e) {
    setIsFeedBackError(false);
    setFeedBackMsg(e.target.value);
  }

  useEffect(() => {
    html2canvas(document.getElementById("forSC"))
      .then((canvas) => {
        canvas.style.display = "none";
        document.body.appendChild(canvas);
        return canvas;
      })
      .then((canvas) => {
        const showImage = canvas.toDataURL("image/png");
        setShowImg(showImage);

        const image = canvas
          .toDataURL("image/png")
          .replace("data:", "")
          .replace(/^.+,/, "");

        const byteCharacters = atob(image);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);
        const newblob = blob.slice(0, blob.size, "image/png");
        //  console.log(newblob,"bne")
        setImage(newblob);
      });







  }, []);

  function submitFeedback() {

    setLoaderActive(true)
    let data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id") || "");
    data.append("call_log_id_ids", localStorage.getItem("call_log_id"));
    data.append("attachment0", image, "Screenshot.png");
    data.append("receiver_user_id_ids", joinCallResult?.remote_user_id || "");
    data.append("call_note", feedBackMsg);
    data.append("ticket_id_ids", localStorage.getItem("ticket_id"));
    dispatch(
      callNote(
        data,
        () => {


          const [localValue] = [...roomValue.localParticipant.dataTracks.values()];

          localValue.track.send("notes_attachment");
          handleCloseAddUser()
          setLoaderActive(false)
          setToasterType("success");
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        },
        () => {
          setLoaderActive(false)
          setToasterType("error");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);

        }
      )
    );

  }


  // Loading effect for the images
  const [isLoadingImg, setIsLoadingImg] = useState(true);

  const handleImageLoaded = () => {
    setIsLoadingImg(false);
  };

  const handleImageError = () => {
    console.error('Failed to load the image.');
    setIsLoadingImg(false);
  };

  // Zoom functionality for the images
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);

  // Function to handle the change in range input
  const handleZoomChange = (event) => {
    setScale(event.target.value);
  };

  // Start dragging
  const handleDragStart = (event) => {
    event.preventDefault();
    setDragging(true);
    // setPosition({
    //     ...position, // Keep the previous position
    //     startX: event.clientX - position.x, // Calculate initial start position
    //     startY: event.clientY - position.y,
    // });

    const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
    const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

    setPosition({
      ...position,
      startX: clientX - position.x,
      startY: clientY - position.y,
    });

  };

  // Handle dragging
  const handleDragging = (event) => {
    if (dragging) {
      // setPosition({
      //     ...position,
      //     x: event.clientX - position.startX,
      //     y: event.clientY - position.startY,
      // });
      const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
      const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

      setPosition({
        ...position,
        x: clientX - position.startX,
        y: clientY - position.startY,
      });
    }
  };

  // Stop dragging
  const handleDragEnd = () => {
    setDragging(false);
  };

  // Reset image
  const handleResetImage = () => {
    setScale(1);
    setPosition({ x: 0, y: 0 });
  }


  return (
    <>

      {
        <>
          <Modal className="fade" size="lg" show={true} centered >
            <div className="row p-3" style={{ maxHeight: '580px' }}>
              <div className="col-6 d-flex justify-content-center ">
                <div
                  className="col-12 px-0"
                  ref={checkHW}
                  style={{ background: "#AAAAAA", position: "relative" }}
                >
                  {isLoadingImg &&
                    <div
                      className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                      style={{
                        maxWidth: `${imgMaxWidth}px`,
                        maxHeight: `${imgMaxHeight}px`,
                        minWidth: `${imgMaxWidth}px`,
                        minHeight: `${imgMaxHeight}px`,
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <Spinner animation="border" size="lg" style={{}} />
                    </div>
                  }

                  <div
                    className='w-100 h-100 d-flex justify-content-center align-items-center overflow-hidden'
                    style={{ cursor: dragging ? 'grabbing' : 'grab' }}
                    onMouseMove={handleDragging}
                    onMouseLeave={handleDragEnd}
                    onMouseUp={handleDragEnd}
                    onTouchMove={handleDragging}
                    onTouchEnd={handleDragEnd}
                  >
                    <img
                      alt=""
                      className=""
                      src={showImg}
                      onLoad={handleImageLoaded}
                      onError={handleImageError}
                      onMouseDown={handleDragStart}
                      onTouchStart={handleDragStart}
                      style={{
                        maxWidth: `${imgMaxWidth}px`,
                        maxHeight: `${imgMaxHeight}px`,
                        minWidth: `${imgMaxWidth}px`,
                        minHeight: `${imgMaxHeight}px`,
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        transition: 'transform 0.25s ease',
                        transformOrigin: 'center',
                        transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                        cursor: dragging ? 'grabbing' : 'grab',
                        display: isLoadingImg ? 'none' : 'block'
                      }}
                    />
                  </div>

                  <span
                    style={{ position: "absolute", top: "6px", left: "6px" }}>
                    <span
                      className="fs-7 px-2 py-1 w-100"
                      style={{
                        color: "grey",
                        background: "white",
                        borderRadius: "20px",
                      }}>
                      Screenshot{" "}
                    </span>
                  </span>

                  {!isLoadingImg &&
                    <div
                      className="w-100 bg-white"
                      style={{ position: "absolute", bottom: "0px", left: "0px" }}
                    >
                      <div className="align-items-center border-2 border-bottom border-white d-flex justify-content-center">
                        <span className="fs-6 font-w600 pe-2">{`Zoom`}</span>
                        <input
                          className=""
                          type="range"
                          min="1"
                          max="3"
                          value={scale}
                          step="0.1"
                          onChange={handleZoomChange}
                          style={{
                            width: '75%',
                            margin: '15px 0',
                            cursor: 'pointer',
                            background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                            borderRadius: '5px',
                            height: '4px',
                            outline: 'none',
                            opacity: '0.7',
                            transition: 'opacity 0.2s',
                          }}
                        />
                        {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                          <div className=' ms-2'>
                            <div className="tooltipCustom">
                              <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                              <i
                                class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                onClick={() => {
                                  handleResetImage();
                                }}
                              ></i>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }

                </div>




              </div>
              <div className="col-6">
                <div
                  className=" px-0 h-100"
                  style={{ display: "flex", flexDirection: "column" }}>
                  <div className="py-2 px-3">
                    <div className="m-0 row">
                      <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                        <span className="">
                          <i className="bi bi-x-lg cursor-pointer" onClick={handleCloseAddUser}></i>
                        </span>
                      </div>
                    </div>

                    <div className="mx-0 row ">
                      <span className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                        Screenshot
                      </span>
                    </div>
                    <div className="mx-0 row mt-3">
                      <span className=" fs-6 px-0 text-center text-gray text-center">
                        Screenshot has been taken and click on save to notes button to save it to your notes.
                      </span>
                    </div>
                  </div>
                  <div
                    className="row mx-0 mt-2"
                    style={{ flex: "1", alignItems: "end" }}>
                    <div className="row px-3" style={{ minHeight: "220px" }}>
                      <div className="col-12 px-0 fs-7  mb-2">
                        <div className="row m-1">
                          <div className="row mx-0">
                            <div className="col-6 d-flex justify-content-start align-items-center fs-7"></div>
                            <div className="col-6 d-flex justify-content-end align-items-center fs-7"></div>
                          </div>
                          <div className="row mx-0">
                            <div
                              className="col-12 d-flex justify-content-start align-items-center fs-6 pt-3"
                            >
                              <div className="col-12 px-0 text-center  ">



                                <div>
                                  <TextArea onChange={onChangeFeedBackMsg}
                                    value={feedBackMsg}
                                    labelName={"Notes"}
                                    errorMessage={"Please enter note here"}
                                    errorOccured={isFeedBackError}
                                  />
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row px-3">
                      <PrimaryButton
                        buttonName={"SAVE TO NOTES"}
                        isLoading={loaderActive}
                        loadingMessage={"SAVING..."}
                        style={{ 
                          border: 'none',
                          background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                          boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                        }}
                        onClick={submitFeedback}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </>
      }

      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={resMessage} />
      )}
    </>
  );
};

export default TwilioRoomScreenShotModal;

